import React, { forwardRef } from "react";
import { Field } from "formik";
import StarIcon from "../../assets/icons/req-star";
import moment from "moment";

const ItemsInputField = forwardRef(
  (
    {
      name,
      label = "Input",
      isLabelReq,
      placeholder,
      labelClass = "min-h-[1.2rem] text-[var(--items-search-input-label-color)] text-xs font-[var(--items-search-label-font-weight)]",
      inputClass = "min-h-[40px] px-2 border border-[var(--items-search-input-border)] focus:outline-none focus:border-[var(--items-search-input-focus)] bg-[var(--items-search-input-bg)] text-[var(--items-search-input-color)] text-[length:var(--items-search-input-font-size)] font-[var(--items-search-input-font-weight)] border-radius input-field-no-spin-buttons",
      onChange = () => {},
      onBlur = () => {},
      onKeyDown = () => {},
      onClick = () => {},
      disabled = false,
      type = "text",
      max,
      min,
      autoFocus = false,
      isRequired = false,
      maxLength,
      alphanumericOnly = false,
      allowAll = false,
    },
    ref
  ) => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const form = e.target.closest("form");
        const nextInput = form?.querySelector("input:not([disabled])");
        if (nextInput) {
          nextInput.focus();
        }
      }

      onKeyDown(e);
    };

    return (
      <Field name={name}>
        {({ field }) => {
          const handleChange = (e) => {
            let value = e.target.value;
            // If allowAll is true, skip all character restrictions
            if (!(type === "text" && allowAll)) {
              // For text type: restrict to alphanumeric by default
              if (type === "text" || alphanumericOnly) {
                value = value.replace(/[^a-zA-Z0-9]/g, "");
                e.target.value = value;
              }
            }

            // Additional maxLength validation for text inputs
            if (type === "text" && maxLength && value.length > maxLength) {
              return; // Prevent updating if exceeds maxLength
            }
            // Additional maxLength validation for text inputs
            if (
              type === "text" &&
              maxLength &&
              e.target.value.length > maxLength
            ) {
              return; // Prevent updating if exceeds maxLength
            }

            field.onChange(e);
            onChange(e);
          };
          const handleBlur = (e) => {
            // Min date validation for date inputs on blur
            if (type === "date" && min && e.target.value) {
              const selectedDate = moment(e.target.value);
              const minDate = moment(min);

              if (selectedDate.isBefore(minDate)) {
                // Clear the field if the date is before min date
                e.target.value = "";
                const syntheticEvent = {
                  ...e,
                  target: {
                    ...e.target,
                    value: "",
                  },
                };
                field.onChange(syntheticEvent);
              }
            }

            onBlur(e);
          };
          return (
            <div className="flex flex-col w-full">
              {isLabelReq && (
                <div className="flex ">
                  <label className={labelClass}> {label} </label>
                  {isRequired && (
                    <span className="ml-2">
                      <StarIcon />
                    </span>
                  )}
                </div>
              )}
              <input
                autoFocus={autoFocus}
                {...field}
                // Always controlled: an undefined value would leave the input
                // showing whatever the previous row / item typed into it
                value={field.value ?? ""}
                ref={ref}
                onBlur={handleBlur}
                max={max}
                min={min}
                type={type}
                disabled={disabled}
                placeholder={placeholder}
                className={inputClass}
                onKeyDown={handleKeyDown}
                onClick={onClick}
                onChange={handleChange}
              />
            </div>
          );
        }}
      </Field>
    );
  }
);

export default ItemsInputField;
